import moment from "moment";

export const getDateInFormatDDMMYYYY = (date: string) => {
  if (date) {
    return moment(date).format("DD.MM.YYYY");
  }

  return "";
};

export const getStringWithoutHTMLTagsAndEntities = (
  htmlString: string
): string => htmlString.replace(/(<([^>]+)>)/gi, "");
